import {
  Navigator,
  NavigatorLocation,
} from '@practicegenius/register-account/src/data/navigator';
import {History} from 'history';
import qs from 'qs';

/**
 * Concrete implementation for sitesDot navigation
 */
export class HistoryNavigator implements Navigator {
  private readonly navigator: History;

  constructor(navigator: History) {
    this.navigator = navigator;
  }

  goBack(): void {
    this.navigator.goBack();
  }

  navigate(route: string, params?: Record<string, unknown>): void {
    if (!this.isCurrentRoute(route)) {
      this.navigator.push(route, params);
    }
  }

  push(route: string, params?: Record<string, unknown>): void {
    this.navigator.push(route, params);
  }

  replace(route: string): void {
    this.navigator.replace(route);
  }

  isCurrentRoute(route: string): boolean {
    return this.navigator.location.pathname === route;
  }

  get location(): NavigatorLocation {
    return {
      pathname: this.navigator.location.pathname,
      params: qs.parse(this.navigator.location.search.slice(1)),
      state: (this.navigator.location.state as Record<string, unknown>) ?? {},
    };
  }

  get listen() {
    return this.navigator.listen;
  }

  get history() {
    return this.navigator;
  }
}
